const Logo = ({ width = 377, height = 140 }: { width?: number; height?: number }) => (
  <svg width={width} height={height} viewBox="0 0 377 140" xmlns="http://www.w3.org/2000/svg">  
  <g transform="translate(20, 17)">
    <rect x="0" y="0" width="48" height="48" fill="#c5f015" />
    <rect x="57" y="0" width="48" height="48" fill="#c5f015" />
    <rect x="0" y="57" width="48" height="48" fill="#c5f015" />
    <rect x="57" y="57" width="48" height="48" fill="#c5f015" />
  </g>
  <g transform="translate(148, 17)">
    <rect x="0" y="0" width="35" height="105" fill="#00c8ff" />
    <rect x="45" y="0" width="35" height="105" fill="#00c8ff" />
  </g>
  <g transform="translate(250, 122)">
    <polygon points="0,0 55,-105 110,0" fill="#fe316c" />
  </g>
</svg>
);

export default Logo;